import useCommonStore from 'www/vue_components/common/TheFilters/lpu/stores/useCommonStore'
import useFiltersStore from 'www/vue_components/common/TheFilters/lpu/stores/useFiltersStore'

function getFiltersUrl() {
  const pathname = generatePathname()
  const search = generateSearch()

  if (search) {
    return `${pathname}?${search}`
  }

  return pathname
}

function generatePathname() {
  const commonStore = useCommonStore()
  const filtersStore = useFiltersStore()

  let path = commonStore.url.lpuList

  if (
    filtersStore.filters.lpuType?.translit === 'chastnaya-stomatologiya'
    && window.location.pathname.includes('kruglosutochnaya-stomatologiya')
  ) {
    path = path.replace('top/lputype-name', 'kruglosutochnaya-stomatologiya')
  } else if (filtersStore.filters.lpuType?.translit) {
    path = path.replace('lputype-name', filtersStore.filters.lpuType.translit)
  } else {
    path = path.replace('top/lputype-name', 'lpu')
  }

  if (filtersStore.filters.place?.townRedirect) {
    path = path.replace('town-name', filtersStore.filters.place.townRedirect.translit)
  } else if (filtersStore.filters.place?.isMetro) {
    path = path.replace('town-name', commonStore.town.regionalCenter.translit)
  } else {
    path = path.replace('town-name', commonStore.town.translit)
  }

  if (filtersStore.filters.place && !filtersStore.filters.place?.townRedirect) {
    if (filtersStore.filters.place.isMetro) {
      path += `metro-${filtersStore.filters.place.translit}/`
    } else {
      path += `d-${filtersStore.filters.place.translit}/`
    }
  }

  return path
}

function generateSearch() {
  const filtersStore = useFiltersStore()
  const query = []

  if (filtersStore.filters.doctorSpeciality) {
    query.push(`spec=${filtersStore.filters.doctorSpeciality.translit}`)
  }

  if (filtersStore.filters.sort) {
    query.push(`sort=${filtersStore.filters.sort}`)
  }

  if (filtersStore.filters.isHighRating !== undefined) {
    query.push('high_rating=true')
  }

  if (filtersStore.filters.isOnlineAppointment !== undefined) {
    query.push('online_appointment=true')
  }

  if (filtersStore.filters.isClubAppointment !== undefined) {
    query.push('club_appointment=true')
  }

  if (filtersStore.filters.timeWork.type === 'custom') {
    query.push(`weekday=${filtersStore.filters.timeWork.weekday}`)
    query.push(`work_time_from=${filtersStore.filters.timeWork.time.from}`)
    query.push(`work_time_to=${filtersStore.filters.timeWork.time.to}`)
  } else if (filtersStore.filters.timeWork.type === '24_7') {
    query.push('h24=true')
  } else if (filtersStore.filters.timeWork.type === 'open_now') {
    query.push('now=true')
  }

  return query.join('&')
}

export default getFiltersUrl
